import { render, staticRenderFns } from "./PlayerAutocomplete.vue?vue&type=template&id=15913d4a&"
import script from "./PlayerAutocomplete.vue?vue&type=script&lang=js&"
export * from "./PlayerAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports